import { Routes, Route } from 'react-router-dom';
import { useIntl } from 'react-intl';
import AuthWrapper from '../common/AuthWrapper';
import RouteWrapper from '../common/RouteWrapper';
import Profile from './Profile';

const ProfileRoutes = () => {
  const intl = useIntl();

  return (
    <Routes>
      <Route
        index
        element={
          <AuthWrapper>
            <RouteWrapper
              title={intl.formatMessage({
                id: 'profile.seo.title',
                defaultMessage: 'ClearVPN | Profile',
                description: 'SEO title of the main user cabinet page',
              })}
            >
              <Profile />
            </RouteWrapper>
          </AuthWrapper>
        }
      />
    </Routes>
  );
};

export default ProfileRoutes;
